import Cookies from "js-cookie";

import { cookieKeyEnum } from "./enum";

export const setToken = (token) => {
  Cookies.set(cookieKeyEnum.token, token, { expires: 1 });
};

export const getToken = () => {
  return Cookies.getJSON(cookieKeyEnum.token);
};

export const removeToken = () => {
  Cookies.remove(cookieKeyEnum.token);
};

export const setUserCode = (userCode) => {
  Cookies.set(cookieKeyEnum.userCode, userCode);
};

export const getUserCode = () => {
  return Cookies.getJSON(cookieKeyEnum.userCode);
};

export const removeUserCode = () => {
  Cookies.remove(cookieKeyEnum.userCode);
};

export const setSecureToken4FirstLogin = (secureToken4FirstLogin) => {
  Cookies.set(cookieKeyEnum.secureToken4FirstLogin, secureToken4FirstLogin);
};
